//
//
//
//
//
//
//
//
//
//
//
import tinymce from 'tinymce/tinymce';
import Editor from '@tinymce/tinymce-vue';
import 'tinymce/themes/silver/theme';
import 'tinymce/plugins/image';
import 'tinymce/plugins/media';
import 'tinymce/plugins/table';
import 'tinymce/plugins/lists';
import 'tinymce/plugins/contextmenu';
import 'tinymce/plugins/wordcount';
import 'tinymce/plugins/colorpicker';
import 'tinymce/plugins/textcolor';
import 'tinymce/plugins/fullscreen';
import 'tinymce/icons/default';
export default {
  components: {
    Editor: Editor
  },
  props: {
    value: {
      type: String,
      required: false
    },
    triggerChange: {
      type: Boolean,
      default: false,
      required: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    plugins: {
      type: [String, Array],
      default: 'lists image media table textcolor wordcount contextmenu fullscreen powerpaste'
    },
    toolbar: {
      type: [String, Array],
      default: 'undo redo |  formatselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | lists image media table | removeformat | fullscreen'
    }
  },
  data: function data() {
    return {
      //初始化配置
      init: {
        language_url: '/tinymce/langs/zh_CN.js',
        language: 'zh_CN',
        skin_url: '/tinymce/skins/lightgray',
        height: 300,
        plugins: this.plugins,
        toolbar: this.toolbar,
        branding: false,
        menubar: false,
        convert_urls: false,
        external_plugins: {
          powerpaste: '/powerpaste/plugin.min.js'
        },
        end_container_on_empty_block: true,
        powerpaste_word_import: 'propmt',
        // 参数可以是propmt, merge, clear，效果自行切换对比
        powerpaste_html_import: 'propmt',
        // propmt, merge, clear
        powerpaste_allow_local_images: true,
        paste_data_images: true,
        images_upload_handler: function images_upload_handler(blobInfo, success) {
          var img = 'data:image/jpeg;base64,' + blobInfo.base64();
          success(img);
        }
      },
      myValue: this.value
    };
  },
  mounted: function mounted() {
    tinymce.init({});
  },
  methods: {
    onClick: function onClick(e) {
      this.$emit('onClick', e, tinymce);
    },
    //可以添加一些自己的自定义事件，如清空内容
    clear: function clear() {
      this.myValue = '';
    }
  },
  watch: {
    value: function value(newValue) {
      this.myValue = newValue;
    },
    myValue: function myValue(newValue) {
      console.log(newValue);

      if (this.triggerChange) {
        console.log(1);
        this.$emit('change', newValue);
      } else {
        console.log(2);
        this.$emit('input', newValue);
      }
    }
  }
};